/**
 * @typedef {Object} PromiseHelperItem
 * @property {Promise} promise
 * @property {Function} resolver
 * @property {Function} rejecter
 */

export class PromiseHelperError extends Error {}

export class PromiseNotFoundError extends PromiseHelperError {}

export default class {
  constructor() {
    this.map = new Map();
  }

  /**
   *
   * @param key
   */
  request(key) {
    let resolver;
    let rejecter;

    const promise = new Promise((resolve, reject) => {
      resolver = resolve;
      rejecter = reject;
    });

    this.map.set(key, {
      promise,
      resolver,
      rejecter,
      isPending: true,
      isRejected: false,
      isFulfilled: false,
    });

    return this;
  }

  resolve(key, payload) {
    this.has(key, true);

    const entry = this.map.get(key);

    entry.isPending = false;
    entry.isFulfilled = true;

    entry.resolver(payload);

    return this;
  }

  /**
   *
   * @param key
   * @param payload
   * @return {*}
   */
  reject(key, payload) {
    this.has(key, true);

    const entry = this.map.get(key);

    entry.isPending = false;
    entry.isRejected = true;

    entry.rejecter(payload);

    return this;
  }

  /**
   *
   * @param {string} key
   * @param {boolean} throwWhenFalse
   * @return {boolean}
   */
  has(key, throwWhenFalse = false) {
    const keyExists = this.map.has(key);

    if (!keyExists && throwWhenFalse) {
      throw new PromiseNotFoundError(`Promise not found (key: '${key}')`);
    }

    return keyExists;
  }

  /**
   *
   * @param key
   * @return {Promise<*>}
   */
  get(key) {
    this.has(key, true);

    return this.map.get(key).promise;
  }

  /**
   *
   * @param {string} key
   * @return {Boolean}
   */
  isPending(key) {
    this.has(key, true);

    return this.map.get(key).isPending;
  }

  /**
   *
   * @param {string} key
   * @return {Boolean}
   */
  isFulfilled(key) {
    this.has(key, true);

    return this.map.get(key).isFulfilled;
  }

  /**
   *
   * @param {string} key
   * @return {Boolean}
   */
  isRejected(key) {
    this.has(key, true);

    return this.map.get(key).isRejected;
  }

  /**
   *
   * @return {Map<*,PromiseHelperItem>}
   */
  getMap() {
    return this.map;
  }
}
